
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sport-gear-storage",
      function () {
        return require("private-next-pages/sport-gear-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sport-gear-storage"])
      });
    }
  